<template>
  <div class="px-5 my-5">
    <div class="mb-3 text-center">
      <h3 class="d-inline me-3 mb-3 fw-bold">Event</h3>
      <BootstrapIcon
        class="add-btn primary"
        icon="plus-circle"
        @click="showModal"
      />
    </div>
    <table class="table table-hover table-bordered align-middle admin-table">
      <caption>
        Event Images
      </caption>
      <thead class="table-light">
        <tr>
          <th scope="col" class="admin-table-preview">Preview</th>
          <th scope="col">Title in EN</th>
          <th scope="col">Title in CH</th>
          <th style="width:25%" scope="col">Content in EN</th>
          <th style="width:25%" scope="col">Content in CH</th>
          <th scope="col">Link</th>
          <th scope="col">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="event._id" v-for="event in eventData">
          <AdminEventTable :event="event" />
        </tr>
      </tbody>
    </table>
    <hr />
    <ModalEvent v-if="displayModal" @close-modal-event="hideModal" />
  </div>
</template>
<script>
import { onMounted, computed } from "vue";
import store from "../../store";
import ModalEvent from "./ModalEvent.vue";
import AdminEventTable from "./AdminEventTable.vue";
export default {
  name: "AdminEvent",
  components: {
    ModalEvent,
    AdminEventTable,
  },
  data() {
    return {
      displayModal: false,
    };
  },
  methods: {
    showModal() {
      this.displayModal = true;
    },
    hideModal() {
      this.displayModal = false;
    },
  },
  setup() {
    onMounted(() => {
      store.dispatch("fetchEventData");
    });

    const eventData = computed(() => store.state.eventData);
    return {
      eventData,
    };
  },
};
</script>
